import api from './api'
import type { NotificationItem } from '@/types'
import type { ApiResponse } from '@/types/api'

const NotificationsService = {
  async getUnreadCount(): Promise<number> {
    const response = await api.get<ApiResponse<{ count: number }>>('/api/v1/notifications/unread-count')
    return Number(response.data.data.count || 0)
  },

  async getAll(limit = 20): Promise<NotificationItem[]> {
    const response = await api.get<ApiResponse<NotificationItem[]>>('/api/v1/notifications', {
      params: { limit },
    })
    return response.data.data
  },

  async markAsRead(notificationId: string): Promise<NotificationItem> {
    const response = await api.patch<ApiResponse<NotificationItem>>(`/api/v1/notifications/${notificationId}/read`)
    return response.data.data
  },

  async markAllAsRead(): Promise<void> {
    await api.patch('/api/v1/notifications/read-all')
  },
}

export default NotificationsService
